import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const isMobile = () => {
  return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
}

export default new Router({
  mode: 'hash',
  routes: [
    // 重定向根路径到对应端首页
    {
      path: '/',
      redirect: () => {
        return isMobile() ? '/mobile' : '/index';
      }
    },
    {
      path: '/index',
      name: 'Index',
      component: () =>
        import ('@/views/pc/index'),
    },
    {
      path: '/news',
      name: 'News',
      component: () =>
        import ('@/views/pc/news'),
    },
    {
      path: '/newsDetail',
      name: 'NewsDetail',
      component: () =>
        import ('@/views/pc/newsDetail'),
    },
    {
      path: '/about',
      name: 'About',
      component: () =>
        import ('@/views/pc/about'),
    },
    {
      //经营领域
      path: '/business',
      name: 'Business',
      component: () =>
        import ('@/views/pc/business'),
    },
    {
      //设施设备
      path: '/facilities',
      name: 'Facilities',
      component: () =>
        import ('@/views/pc/facilities'),  
    },
    {
      //联系我们
      path: '/contact',
      name: 'Contact',
      component: () =>
        import ('@/views/pc/contact'),  
    },
    {
      //合作伙伴
      path: '/partners',
      name: 'Partners',
      component: () =>
        import ('@/views/pc/partners'),  
    },
    {
      //人力资源
      path: '/resources',
      name: 'Resources',
      component: () =>
        import ('@/views/pc/resources'),  
    },
    {
      path: '/mobile',
      name: 'M_Index',
      component: () =>
        import ('@/views/mobile/index'),
    },
    {
      path: '/mobile/news',
      name: 'M_News',
      component: () =>
        import ('@/views/mobile/news'),
    },
    {
      path: '/mobile/newsDetail',
      name: 'M_NewsDetail',
      component: () =>
        import ('@/views/mobile/newsDetail'),
    },
    {
      path: '/mobile/about',
      name: 'M_About',
      component: () =>
        import ('@/views/mobile/about'),
    },
    {
      //经营领域
      path: '/mobile/business',
      name: 'M_Business',
      component: () =>
        import ('@/views/mobile/business'),
    },
    {
      //设施设备
      path: '/mobile/facilities',
      name: 'M_Facilities',
      component: () =>
        import ('@/views/mobile/facilities'),  
    },
    {
      //联系我们
      path: '/mobile/contact',
      name: 'M_Contact',
      component: () =>
        import ('@/views/mobile/contact'),  
    },
    {
      //合作伙伴
      path: '/mobile/partners',
      name: 'M_Partners',
      component: () =>
        import ('@/views/mobile/partners'),  
    },
    {
      //人力资源
      path: '/mobile/resources',
      name: 'M_Resources',
      component: () =>
        import ('@/views/mobile/resources'),  
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js